<template>
  <div
    class="q-if row no-wrap relative-position q-input q-if-inverted q-if-inverted-light q-if-has-content bg-white text-black no-shadow generic-border"
  >
    <div class="q-if-inner col column">
      <div class="row no-wrap relative-position items-center">
        <cleave
          v-model="model"
          class="col q-input-target q-no-input-spinner ellipsis"
          placeholder="-"
          :options="{
            time: true,
            timePattern: ['h', 'm']
          }"
          @input="handleInput"
        />

        <span v-if="date" class="text-light cursor-pointer" @click="$emit('clickDate')">
          {{ dateFormatted }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import Cleave from 'vue-cleave-component'
  import { distanceInWordsOrFormat } from 'src/utils/date'

  export default {
    props: {
      value: {
        required: false,
        type: String
      },

      date: {
        type: Date
      }
    },

    data () {
      return {
        model: null
      }
    },

    computed: {
      dateFormatted () {
        return distanceInWordsOrFormat(this.date, 1, this.$t('date_format_short'))
      }
    },

    methods: {
      handleInput (value) {
        this.$emit('input', value)
      }
    },

    watch: {
      value: function (newValue) {
        this.model = newValue
      }
    },

    components: {
      Cleave
    }
  }
</script>
